// frontend/src/components/auth/register/registerTranslations.ts

export interface Languages {
  [key: string]: {
    registerTitle: string;
    steps: {
      accountData: string;
      projectInfo: string;
    };
    fullName: string;
    email: string;
    password: string;
    confirmPassword: string;
    projectName: string;
    phone: string;
    website: string;
    back: string;
    next: string;
    finish: string;
    alreadyHaveAccount: string;
    login: string;
    validations: {
      fullNameMin: string;
      fullNameRequired: string;
      emailInvalid: string;
      emailRequired: string;
      passwordMin: string;
      passwordRequired: string;
      passwordsMustMatch: string;
      confirmPasswordRequired: string;
      projectNameMin: string;
      projectNameRequired: string;
      phoneInvalid: string;
      phoneRequired: string;
      websiteInvalid: string;
    };
    errorDefault: string;
  };
}

export const translations: Languages = {
  pt: {
    registerTitle: "CRIAR CONTA",
    steps: {
      accountData: "Dados da Conta",
      projectInfo: "Informações do Projeto"
    },
    fullName: "Nome Completo",
    email: "E-mail",
    password: "Senha",
    confirmPassword: "Confirmar Senha",
    projectName: "Nome do Projeto",
    phone: "Telefone",
    website: "Website (opcional)",
    back: "Voltar",
    next: "Próximo",
    finish: "Concluir",
    alreadyHaveAccount: "Já tem conta?",
    login: "Faça login",
    validations: {
      fullNameMin: "Mínimo 5 caracteres",
      fullNameRequired: "Obrigatório",
      emailInvalid: "E-mail inválido",
      emailRequired: "Obrigatório",
      passwordMin: "Mínimo 8 caracteres",
      passwordRequired: "Obrigatório",
      passwordsMustMatch: "Senhas não coincidem",
      confirmPasswordRequired: "Obrigatório",
      projectNameMin: "Mínimo 3 caracteres",
      projectNameRequired: "Obrigatório",
      phoneInvalid: "Número de telefone inválido",
      phoneRequired: "Obrigatório",
      websiteInvalid: "URL inválido"
    },
    errorDefault: "Ocorreu um erro ao tentar criar sua conta. Tente novamente."
  },
  en: {
    registerTitle: "CREATE ACCOUNT",
    steps: {
      accountData: "Account Data",
      projectInfo: "Project Information"
    },
    fullName: "Full Name",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    projectName: "Project Name",
    phone: "Phone",
    website: "Website (optional)",
    back: "Back",
    next: "Next",
    finish: "Finish",
    alreadyHaveAccount: "Already have an account?",
    login: "Sign in",
    validations: {
      fullNameMin: "Minimum 5 characters",
      fullNameRequired: "Required",
      emailInvalid: "Invalid email",
      emailRequired: "Required",
      passwordMin: "Minimum 8 characters",
      passwordRequired: "Required",
      passwordsMustMatch: "Passwords don't match",
      confirmPasswordRequired: "Required",
      projectNameMin: "Minimum 3 characters",
      projectNameRequired: "Required",
      phoneInvalid: "Invalid phone number",
      phoneRequired: "Required",
      websiteInvalid: "Invalid URL"
    },
    errorDefault: "An error occurred while trying to create your account. Please try again."
  }
};
